module.exports = __webpack_public_path__ + "media/images/flags/st-9a8dbcaa662599be5e980a068dcf031d.svg";